import {FC, useMemo, Badge} from 'external/react'

type DualBadgeProps =  {
	active: boolean
	labels: [string, string]
	badgeProps?: any
}

const DualBadge: FC<DualBadgeProps> = props => {
	const {labels, active, badgeProps = {}} = props 
	const [bg, label] = useMemo(() => active ? ['success', labels[0]] : ['danger', labels[1]], [labels, active])
	return <Badge bg={bg} {...badgeProps}>{label}</Badge>
}

export {DualBadge as default}